import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  color: #666;

  hgroup {
    display: flex;
    align-items: baseline;
    justify-content: center;
    margin-bottom: 1rem;

    h1 {
      font-size: 3rem;
      margin-right: 0.5rem;
    }

    h2 {
      font-weight: 400;
      font-size: 1.4rem;
    }
  }
`;

export const Items = styled.ul`
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  li + li {
    border-left: 1px solid rgba(0, 0, 0, 0.3);
  }
`;

export const Item = styled.li`
  padding: 1rem;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  svg {
    font-size: 3rem;
    margin-bottom: 1rem;
  }

  p {
    text-align: center;
    margin: 0;
    font-size: 1.15rem;
  }

  h1 {
    display: flex;
    align-items: center;
    justify-content: baseline;

    margin: 0;
    padding: 0;

    font-size: 2rem;

    span {
      font-weight: 400;
      font-size: 1.3rem;
    }
  }

  @media (max-width: 320px) {
    padding: 0.5rem;

    p {
      font-size: 1rem;
    }

    h1 {
      font-size: 1.5rem;

      span {
        font-size: 0.9rem;
      }
    }
  }
`;

export const Form = styled.div`
  width: 30rem;

  display: flex;
  flex-direction: column;

  margin-bottom: 1.5rem;

  > div:not(:first-child) {
    margin-top: 1.5rem;
  }

  @media (max-width: 375px) {
    width: 26.5rem;
  }
`;
